import React from "react";
import { map } from "lodash";
import { Fieldset, Label, Radio } from "@ui-kit/form";

type Value = string | boolean;

export interface IProps {
  label?: string;
  value: string;
  options: { value: Value; label: string }[];
  onChange: (value: Value) => void;
  disabled?: boolean;
  inline?: boolean;
}

const PanelsCardEditionSidebarRadios = ({
  options,
  value,
  onChange,
  label,
  disabled,
  inline,
}: IProps) => (
  <Fieldset disabled={disabled}>
    <Label>{label}</Label>
    {map(options, (option, i) => (
      <Radio
        key={i}
        label={option.label}
        checked={option.value === value}
        onClick={() => onChange(option.value)}
        inline={inline}
      />
    ))}
  </Fieldset>
);

export default PanelsCardEditionSidebarRadios;
